<template>
    <div class="sessionstest">
        <Header/>

        <div name="bizzabo-web-agenda" data-unique-name="243526" data-events-url="https://events.bizzabo.com"></div>

    </div>
</template>





<script>
    import Header from "../components/Header.vue";
    export default {
        name: "SessionsTest",
        components: {
            Header
        },
        mounted() {
            /* Bizzabo TEST Web Agenda Begin */
            var bz = document.createElement('script');
            bz.type = 'text/javascript';
            bz.async = true;
            bz.src = 'https://organizer.bizzabo.com/widgets/agenda/agenda.js';
            var s = document.getElementsByTagName('script')[0];
            s.parentNode.insertBefore(bz, s);
            /* Bizzabo TEST Web Agenda End */
        }
    }


</script>

